/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import {
  FlexContainer,
  Heading,
  SVGIcon,
  Text,
  theme,
  Tooltip,
} from "@nordcloud/gnui";
import { SidebarIconWrap, SidebarItemWrapper } from "~/components/Styled";
import { SidebarItemProps, UISidebarProps } from "./types";

export function SidebarItem({
  hasSubtitle = false,
  hasIcon,
  item,
  onSubmit,
  disabled,
}: SidebarItemProps & UISidebarProps) {
  const status = item?.icon ? "success" : "danger";
  const caption = item?.icon ? "Activated" : "Disabled";
  const iconName = item?.icon ? "cloudSuccess" : "cloudError";

  return (
    <SidebarItemWrapper
      title={item?.value}
      hasIcon={hasIcon}
      data-testid="sidebar-item"
      disabled={disabled}
      onClick={() => onSubmit(item.value)}
    >
      {hasSubtitle ? (
        <>
          {hasIcon && (
            <SidebarIconWrap>
              <Tooltip status={status} caption={caption} hideTimeout={0}>
                <SVGIcon name={iconName} data-testid="sidebar-item-icon" />
              </Tooltip>
            </SidebarIconWrap>
          )}
          <FlexContainer
            direction="column"
            alignItems="flex-start"
            css={{ textAlign: "left" }}
          >
            <Heading level={4}>{`${item?.label}`}</Heading>
            <Text size="sm" tag="div" color={theme.color.text.text02}>
              {item?.value}
            </Text>
          </FlexContainer>
        </>
      ) : (
        <Heading level={5}>{`${item?.value}`}</Heading>
      )}
    </SidebarItemWrapper>
  );
}
